import { Excess, PaymentFrequency, YesNoAnswer } from 'scenes/common/types';
import {
  CoverOptionsData,
  SpecifiedContent,
  SpecifiedContentCover,
} from 'scenes/home/types';

export const defaultSpecifiedContent: SpecifiedContent = {
  id: -1,
  category: '',
  description: '',
  itemValue: '',
  cover: SpecifiedContentCover.Unspecified,
};

export const defaultHomeCoverOptions: CoverOptionsData = {
  preselectedPaymentFrequency: PaymentFrequency.Annually,
  selectedExtras: [],
  specifiedContentsAnswer: YesNoAnswer.Unspecified,
  specifiedContents: [],
  specifiedContent: defaultSpecifiedContent,
  unspecifiedPortableContents: YesNoAnswer.Unspecified,
  unspecifiedPortableContentsLimit: '',
  isPortableContentsExtraSelected: false,
};

export const defaultExcess: Excess = {
  id: '',
  type: '',
  amount: 0,
};
